/** @typedef {('en'|'es')} Locale */
/** @type {[Locale, ...Locale[]]} */
export const locales = ['en','es']